import { useCallback } from 'react';
import { useAppSelector } from '~/hooks/useAppSelector';

/**
 * A check against the signed-in office's favorite professionals. The user record's
 * `favoriteProfessionals` holds professional ids at runtime, though `IUser` types
 * it as `IUser[]` — the same cast `JobSummaryRating` and `CompletedShiftDetailsPage`
 * document.
 */
export const useIsFavoriteProfessional = (): ((professionalId?: string) => boolean) => {
  const favoriteProfessionalIds = useAppSelector(
    (state) => (state.user.user?.favoriteProfessionals ?? []) as unknown as string[],
  );

  return useCallback(
    (professionalId?: string) =>
      !!professionalId && favoriteProfessionalIds.includes(professionalId),
    [favoriteProfessionalIds],
  );
};
